'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name browserDetection
    * @description Handles browser detection
    **/

    var isMobileDevice = function () {
        let deviceAgent = navigator.userAgent.toLowerCase();
        let isMobileDevice = (deviceAgent.match(/(iphone|ipod|ipad)/) ||
            deviceAgent.match(/(android)/) ||
            deviceAgent.match(/(iemobile)/) ||
            deviceAgent.match(/iphone/i) ||
            deviceAgent.match(/ipad/i) ||
            deviceAgent.match(/ipod/i) ||
            deviceAgent.match(/blackberry/i) ||
            deviceAgent.match(/bada/i)
        );

        return isMobileDevice
    };

    var addBrowserClass = function (selector) {
        var Environment = {};
        Environment.isMac = navigator.platform.toLowerCase().indexOf('mac') > -1;
        Environment.isChrome = navigator.userAgent.indexOf('Chrome') > -1;
        Environment.isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') == -1;
        Environment.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        Environment.isIE = navigator.userAgent.toLowerCase().indexOf('MSIE ');
        Environment.isIE9 = navigator.userAgent.indexOf('Trident/5.0') > -1;

        var htmlClass;
        if (Environment.isChrome) {
            htmlClass = 'chrome';
        } else if (Environment.isFirefox) {
            htmlClass = 'firefox';
        } else if (Environment.isSafari) {
            htmlClass = 'safari';
        } else if (Environment.isIE) {
            htmlClass = 'ie';
            if (Environment.isIE9) {
                browserClass = 'ie9';
            }
        }

        $(selector).addClass(htmlClass);

        if (Environment.isMac) {
            $(selector).addClass('mac os');
        } else {
            $(selector).addClass('win os');
        }

        return Environment;
    }

    return {
        isMobileDevice: isMobileDevice,
        addBrowserClass: addBrowserClass
    };
}())